import { render, staticRenderFns } from "./EncounterbyLGA.vue?vue&type=template&id=3ba24eb0&"
import script from "./EncounterbyLGA.vue?vue&type=script&lang=js&"
export * from "./EncounterbyLGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports